import { render, staticRenderFns } from "./NewProjectWorker.vue?vue&type=template&id=6a6d3b7b&scoped=true"
import script from "./NewProjectWorker.vue?vue&type=script&lang=js"
export * from "./NewProjectWorker.vue?vue&type=script&lang=js"
import style0 from "./NewProjectWorker.vue?vue&type=style&index=0&id=6a6d3b7b&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6a6d3b7b",
  null
  
)

export default component.exports